// extracted by mini-css-extract-plugin
export default {"title":"Parts_title__cYr52"};